import { TKeys } from './types'

export const pt_pt: Record<TKeys, string> = {
    ...require('./en-en').en_en, // TODO
    // SCREENS
    // General
    loading: 'Carregando...',
    // SignIn
    signin_title: 'Iniciar sessão',
    signin_redirect_title: 'Verificar sua senha de acesso',
    psw_placeholder_redirect: "Confirmar senha",
    psw_placeholder: 'Insira sua senha',
    email_placeholder: 'Endereço de e-mail',
    language: 'Língua',
    forgot_password: 'Esqueceu sua senha?',
    signup_hint: 'Não tem conta? Registe-se',
    btn_signin: 'Iniciar sessão',
    // Intro
    // N-Ary sort
    my_profile: 'Meus preferências',
    btn_submit: 'Enviar',
    btn_finish: 'Concluir',
    hint_undo: 'Tem certeza de que deseja desfazer sua última ação?',
    // Global screen
    tip_quit: 'Tem certeza de que deseja sair?',
    // State screen // Tell us, what is your ideal work environment?
    intro_title: 'A felicidade é a chave para o sucesso',
    intro_body: `Se você amar o que faz e a equipe com a qual trabalha, será bem-sucedido em sua vida profissional.`,
    howto1_title: `Você verá 2 declarações
    
    Clique na que preferir

    Isso apenas levará 12 minutos.`,
    howto1_body: 'Deve ser realizado este teste em um ambiente silencioso.',
    award1_title: 'Muito bem feito!',
    award1_body: `No topo da lista seguinte, você encontrará o que considera ser as coisas mais importantes em seu ambiente de trabalho ideal. Se desejar, pode rearranjar a ordem das declarações arrastando e soltando-as.`,
    award2_title: 'Você já está mais da metade feito !',
    award2_body: `Suas declarações mais críticas estão direto no topo desta lista. Sinta o prazer de rearranjar-as ao seu contento, apenas arrastando e soltando-as Seu espaço de trabalho sonhado está apenas um movimento longe!`,
    award3_title: 'Parabéns pelo terceiro parte',
    award3_body: `Você está quase lá A linha de chegada está à vista Inspire-se, dê o seu melhor nestes momentos finais e celebre o incrível feito que o aguarda. Você tem isso Conclua forte e permita que a história de sucesso se desenrole!`,
    howto2_title: 'E agora as últimas perguntas - ±2 minutos',
    howto2_body: `Você será perguntado algumas perguntas adicionais. Terá que escolher o melhor ou o pior entre algumas das declarações que já classificou. Isso nos permite combinar todas as três rodadas de sua personalidade`,
    title_rank: 'Em meu ambiente de trabalho **IDEAL**',
    subtitle_rank_2: 'o que mais importa é ...',
    subtitle_rank_n: 'Onde você colocaria a declaração seguinte?',
    hint_reorder: 'Rearranje como necessário, da mais importante à menos importante',
    hint_overview: 'Clique abaixo para ver o resumo',
    hint_profile: 'Meus Preferências Atuais',
    hint_place_below: 'Coloque a declaração abaixo',
    title_rank_bucket: 'Comparações muito últimas',
    subtitle_rank_best: 'Este tempo, qual é a mais importante para você?',
    subtitle_rank_least: 'Qual é a MENOS importante para você?',
    subtitle_rank_reorder: 'Rearranje da MAIS importante à MENOS importante',
    title_thanks: 'Muito bem feito!',
    hint_thanks: 'Sua preferência foi enviada com sucesso',
    title_error: 'Não podemos enviar seus dados',
    hint_error: 'Por favor, tente novamente mais tarde ...',
    hint_error_validation: 'Ocorreu um erro de validação, por favor, tente novamente mais tarde',
    hint_error_dup: 'Você já enviou um relatório anterior.',
    hint_confirm_round: 'Tem certeza de que deseja confirmar esta classificação?',
    retry_btn: 'repetir',
    btn_to_overview: 'VISÃO GERAL',
    btn_to_bucket_x: 'CESTO',
    btn_to_params: 'PARÂMETROS',
    btn_open: 'ABRIR',
    btn_start: 'INICIAR',
    btn_confirm: 'CONFIRMAR',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'PRÓXIMO',
    btn_next_round: 'ROUNDA PRÓXIMA',
    // btn_prev: 'PREV',
    btn_prev: '<',
    btn_cancel: 'CANCELAR',
    // btn_back: 'BACK',
    btn_back: '<',
    btn_download: 'Baixe seu relatóri',
    btn_quit: 'SAIR',
    // Comparisons
    pick_best: 'Qual é o mais importante para você?',
    pick_worst: 'Qual é o menos importante para você?',
    vs: 'OU',
    // UI elements
    round: 'Rodada',
    stm: 'Declaração',
    bucket: 'Cesto',
    axis_y: 'Número de Decl',
    tip_saved: 'Salvar',
    top_scale_hint: 'O **MAIS** importante',
    bottom_scale_hint: 'O **MENOS** importante',
    pick_tip: 'Selecionado!',
    how_to_binary_title: 'Intruções',
    // values
    samen: 'Colaboração',
    conf: 'Conformidade',
    erken: 'Reconhecimento',
    zorg: 'Cuidado',
    gelijk: 'Igualdade & diversidade',
    zelfsturing: 'Autonomia',
    macht: 'Poder',
    voorspelbaar: 'Previsibilidade',
    prestatie: 'Desempenho',
    zelfontplooi: 'Desenvolvimento pessoal',
    duurzaam: 'Sustentabilidade',
    integriteit: 'Integridade',
    innovatie: 'Inovação',
    daadkracht: 'Força',
    // 
    no_slug_error: 'Por favor, certifique-se de que seguiu o link correto, se não, contate o administrador',
    unknown_error: 'Ocorreu um erro desconhecido, por favor, tente novamente mais tarde',
    invalid_credentials: 'Combinação de e-mail/senha inválida',
    // 360:
    // TLTM Scale
    lvl0: 'Por favor, selecione',
    lvl1: 'Demasiado pouco',
    lvl2: 'Muito pouco',
    lvl3: 'Um pouco muito pouco',
    lvl4: 'Quantidade certa',
    lvl5: 'Um pouco muito',
    lvl6: 'Muito demais',
    lvl7: 'Demasiado demais',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Quantidade certa',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Por favor, selecione',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Nunca',
    lvlSC10x0: 'Nul0',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Muito ruim',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Ruim',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Péssimo',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Insuficiente',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Médiocre',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Médio',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Bom',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Muito bom',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Excelente',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Certamente',
    lvlSC10x10: 'Impecável',
    howto_360_title: `Como organização, damos grande importância às valores, acreditamos que é essencial saber o que o faz realmente feliz no seu ambiente de trabalho.`,
    howto_360_body: `Este questionário é e permanecerá anônimo para sua hierarquia, que não receberá apenas os resultados agregados`,
    picker_360_title_workenv: "No meu ambiente de trabalho atual …",
    picker_360_title_leadership: "Meu gerente direto …",
    nps_title: "Você recomendaria trabalhar aqui para alguém que você conhece?",
    comment_title: 'Adicione um comentário',
    comment_placeholder: 'Agradecemos qualquer feedback construtivo sobre esta declaração',
    comment_save: 'Salvar e fechar',
    comment_remaining: 'character(s) left',
    howto_workenv_title: 'And now, your work environment',
    howto_workenv_body: 'What about it ? Last questions, we promise!',
    howto_nps_title: "",
    howto_nps_body: "",
  // legacy_v2:
    btn_next_step: 'Seguinte',
    to_assign: 'Por atribuir',
    least_important: 'Menos importante',
    moderately_important: 'Moderadamente importante',
    most_important: 'Mais importante',
    ranker_title: 'O que é importante para ti no teu trabalho ideal?',
    too_insufficient_warning: 'Este grupo contém afirmações insuficientes',
    too_much_warning: 'Este grupo contém afirmações a mais',
    too_much_warning1: 'Atribuíste afirmações a mais ao(s) seguinte(s) grupo(s):',
    too_much_warning2: 'Clica no grupo e move as afirmações para outro até que a distribuição esteja correta',
    empty_bin: 'Este grupo está vazio',
    // further_ranking: 'Por favor, classifica mais detalhadamente as {{v1}} afirmações que assinalaste como "{{v2}}"',
    further_ranking: 'O que é importante para ti no teu trabalho ideal?',
    hint_modal_title: 'Imagina o teu ambiente de trabalho ideal',
    hint_modal_body1: 'Classifica 42 afirmações sobre o teu ambiente ideal do menos ao mais importante',
    hint_modal_body2_left: 'esquerda',
    hint_modal_body2_left_txt: 'as 11 afirmações que consideras menos importantes',
    hint_modal_body2_right: 'direita',
    hint_modal_body2_right_txt: 'as 11 afirmações que consideras mais importantes',
    hint_modal_body2_middle: 'meio',
    hint_modal_body2_middle_txt: 'as 20 afirmações que consideras moderadamente importantes',
    hint_modal_body3: 'Arrasta e larga cada afirmação no grupo que te convém melhor',
    hint_modal_cta: 'Iniciar',
    hint_top: 'Rolar para cima',
    hint_down: 'Rolar para baixo',
    final_distribution_invalid_title: 'A distribuição final é inválida',
    final_distribution_invalid_body: 'Há {{v1}} caixa(s) com demasiadas declarações e {{v2}} caixa(s) com muito poucas declarações',
    no_available_bins_warning: 'Não há caixas disponíveis para atribuição aleatória - todas as caixas estão na capacidade máxima',
    sort_middle_bucket_title: 'Gostaria de classificar a caixa do meio?',
    sort_middle_bucket_body: 'Isso classificará a caixa do meio por valor.',
    reflect_current_view_title: 'Isso reflete sua visão atual?',
    reflect_current_view_sort_body: 'Se não, será oferecido para classificar sua classificação final',
    yes: 'Sim',
    no: 'Não',
    final_ranking: 'Classificação Final',
    example: 'Exemplo :',
}